import React from "react";
import CrudPage from "./CrudPage";
export default function AdminNews() {
  return <CrudPage title="Berita" endpoint="news" testPrefix="news" fields={[
    {key: "title", label: "Judul"},
    {key: "category", label: "Kategori"},
    {key: "date", label: "Tanggal (YYYY-MM-DD)"},
    {key: "excerpt", label: "Ringkasan", type: "textarea"},
    {key: "body", label: "Isi", type: "textarea"},
    {key: "photo_url", label: "URL Foto"},
  ]} />;
}
